// $(document).ready(function () {
//   $("a").each(function () {
//     if (this.href.indexOf("/collections/") != -1) {
//       if (this.href.indexOf("/products/") != -1) {
//       } else if (this.href.indexOf("v.availability") != -1) {
//       } else {
//         var oldUrl = $(this).attr("href");
//         var vl = "?filter.v.availability=1&filter.p.tag=all";
//         var newUrl = oldUrl.replace(oldUrl, oldUrl + vl);
//         $(this).attr("href", newUrl);
//       }
//     }
//   });
//   var ur = location.href;
//   var vl = "?filter.v.availability=1&filter.p.tag=all";
//   if (window.location.href.indexOf("/collections/") != -1) {
//     if (window.location.href.indexOf("p.tag=all") != -1) {
//     } else if (window.top.location.pathname.indexOf("/admin/themes/") === 0) {
//     } else {
//       location.replace(ur + vl);
//     }
//   }
// });

$(document).ready(function () {
  var backButton =
    '<img alt="Previous Arrow" src="https://cdn.shopify.com/s/files/1/2239/6447/files/back.png?v=1692747297" class="slick-prev meta-three-col-arrow">';
  var nextButton =
    '<img alt="Next Arrow" src="https://cdn.shopify.com/s/files/1/2239/6447/files/right-arrow_1.png?v=1692747517" class="slick-next meta-three-col-arrow">';

  $(".three-col-img-row-test").slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: backButton,
    nextArrow: nextButton,
    cssEase: "linear",
    speed: 300,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: true,
          infinite: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
